import { v4 as uuidv4 } from 'uuid';

export const HEADER_NAME = 'X-PB-Client-Context-Id';

const clientContextIdHeader: Record<string, string> = {
  [HEADER_NAME]: uuidv4(),
};

export const getClientContextIdHeader = (): Record<string, string> => ({
  ...clientContextIdHeader,
});

export const createClientContextIdHeaderFromValue = (clientContextId: string): Record<string, string> => {
  clientContextIdHeader[HEADER_NAME] = clientContextId;

  return clientContextIdHeader;
};

export const regenerateClientContextIdHeader = (): Record<string, string> => {
  clientContextIdHeader[HEADER_NAME] = uuidv4();

  return clientContextIdHeader;
};
